import personalizeService from '../utils/rbmc.personalizeService';
import logger from '../utils/rbmc.logger';
const CSRF_TOKEN = 'CSRFToken';
(() => {
    personalizeService.getPersonalizedData().then((data) => {
        logger.debug(`Setting CSRF Token: ${data.csrfToken}`);
        ACC.config.CSRFToken = data.csrfToken;
    }, (jqXHR) => {
        logger.error(`fetchAndSetCSRFToken, code: ${jqXHR.status}`);
    })
})();
// Taken from OOTB 2005 Accelerator: add a CSRF request token to POST ajax request if its not available
$.ajaxPrefilter((options, originalOptions, jqXHR) => {
    // Modify options, control originalOptions, store jqXHR, etc
    if (options.type.toLowerCase() === "post") {
        const noData = (typeof options.data === "undefined");
        if (noData) {
            options.data = `${CSRF_TOKEN}=${ACC.config.CSRFToken}`;
        } else {
            const contentTypePattern = /application\/json/i;
            const urlPattern = /t\/upload/i;
            if (options.data instanceof window.FormData) {
                if(urlPattern.test(options.url)){
                    // if it is the contact file upload, then append CSRF to the header.
                    jqXHR.setRequestHeader(CSRF_TOKEN, ACC.config.CSRFToken);
                } else {
                    options.data.append(CSRF_TOKEN, ACC.config.CSRFToken);
                }
            } else if (contentTypePattern.test(options.contentType) || (urlPattern.test(options.url))) {
                // if its a json post or the contact upload, then append CSRF to the header.
                // sometimes we end up here depending on the captcha for the contact page
                jqXHR.setRequestHeader(CSRF_TOKEN, ACC.config.CSRFToken);
            } else if (options.data.indexOf(CSRF_TOKEN) === -1) {
                options.data = `${options.data}&${CSRF_TOKEN}=${ACC.config.CSRFToken}`;
            }
        }
    }
});
